// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Kp-z","slideIn":"Lp-z"};